module.exports = __webpack_public_path__ + "static/media/terminated_departure_station_icon.12d16bba.svg";